<script lang="ts" setup>
import { computed } from 'vue';
import { GpTag, GpTooltip } from '@gportal/uikit';

type Tags = { [key: string]: string };

const props = defineProps<{
  tags?: Tags;
  single?: boolean;
}>();

const shownTags = computed(() => {
  const tags = {
    ...props.tags,
  };

  if (props.single && Object.entries(tags).length > 0) {
    return Object.entries(tags).slice(0, 1);
  }

  return Object.entries(tags);
});

const additionalTags = computed(() => {
  const tags = new Array<string>();
  if (!props.single) {
    return tags;
  }

  if (props.tags) {
    let i = 0;
    Object.entries(props.tags).forEach(([key, value]) => {
      if (i > 0) {
        tags.push(`${key}/${value}`);
      }
      i += 1;
    });
  }

  return tags;
});

const moreTags = computed(() => {
  let length = 0;

  if (props.tags) {
    Object.entries(props.tags).forEach(() => {
      length += 1;
    });
  }

  const moreTags = length - 1;
  if (!props.single || moreTags <= 0) {
    return '';
  }

  return `+${moreTags.toString()}`;
});
</script>

<template>
  <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
    <span
      class="tw-block tw-h-5 tw-rounded tw-border tw-border-gp-ocean tw-text-xs tw-leading-4"
      v-for="tag in shownTags"
      :key="tag[0]"
    >
      <span
        class="tw-inline-block tw-h-full tw-rounded-l-sm tw-bg-gp-ocean tw-px-2 tw-text-black"
        >{{ tag[0] }}</span
      >
      <span class="tw-inline-block tw-h-full tw-rounded-r-sm tw-px-2">{{ tag[1] }}</span>
    </span>
    <GpTooltip
      v-if="moreTags.length > 0"
      class="!tw-block tw-h-4"
      :content="additionalTags.join(', ')"
      placement="top"
    >
      <GpTag size="xs" :label="moreTags" class="!tw-block" />
    </GpTooltip>
  </div>
</template>
